import axios from "axios";

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api', 
  baseURL: process.env.REACT_APP_API_URL || `http://${window.location.hostname}:3001/api`,
  // baseURL: `http://${window.location.hostname}:3001/api`,

});

const openaiApiKey = process.env.REACT_APP_OPENAI_KEY;
const openaiApiInstance = axios.create({
  baseURL: "https://api.openai.com/v1",
  headers: {
    "Authorization": `Bearer ${openaiApiKey}`,
  },
});

export { api, openaiApiInstance as openaiApi };